import {
  AssetTemplateSubCategoryType,
  LanguageType,
  LoadingStatusType,
  TypeComponentNoti,
  ValidatedErrorCarryBalanceType,
} from "@/enums/enums";
import {
  ConvertToImportAssetTemplateList,
  ConvertToInsertAssetTemplateList,
  ConvertToUnitTemplateModel,
  GetAssetTemplateCode,
  GetImportAssetCarryBalanceList,
  GetInsertAssetCarryBalance,
  GetUpdateAssetCarryBalance,
  SetTapAssetDepreciationTable,
  SetTapAssetTable,
  SetTapAssetTemplateTable,
  SetTapAssetUnitTable,
  ValidateAssetCarryBalance,
  ValidateAssetCarryBalanceForUpdate,
  ValidateUnitTemplateError,
  ValidatedCreateAssetTemplate,
} from "@/helper/assetHelper";
import { GetMessageExceptionCode, NewObject } from "@/helper/shareHelper";
import { GetLanguageType, MerchantId } from "@/helper/userHelper";
import { i18n } from "@/i18n";
import { AssetModel, AssetTemplateModel, AssetUnitModel } from "@/model/asset/assetModel";
import {
  AssetDepreciationTableModel,
  AssetTableModel,
  AssetTemplateTableModel,
  AssetUnitTableModel,
} from "@/model/asset/assetTableModel";
import router from "@/router";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import {
  ConvertToAssetDepreciationTable,
  ConvertToAssetDetail,
  ConvertToAssetTable,
  ConvertToAssetTemplateDetail,
  ConvertToAssetTemplateList,
  ConvertToAssetTemplateTable,
  ConvertToAssetUnitTable,
} from "../../service/asset/assetFacade";
import AssetService from "../../service/asset/assetService";

@Module({ namespaced: true })
class Asset extends VuexModule {
  private assetTemplateTableLoadingStatus = LoadingStatusType.None;
  private assetUnitTableLoadingStatus = LoadingStatusType.None;
  private assetUnitTable: Array<AssetUnitTableModel> = [];
  private assetTableLoadingStatus = LoadingStatusType.None;
  private assetDepreciationTableLoadingStatus = LoadingStatusType.None;
  private assetTemplateTable: Array<AssetTemplateTableModel> = [];
  private assetTemplateTableTap: any = [];
  private assetTable: Array<AssetTableModel> = [];
  private assetTableTap: any = [];
  private assetUnitTableTap: any = [];
  private assetDepreciationTable: Array<AssetDepreciationTableModel> = [];
  private assetDepreciationTableTap: any = [];
  private assetDetail: AssetModel | null = null;
  private assetDetailLoadingStatus = LoadingStatusType.None;
  private assetTemplateDetail: AssetTemplateModel | null = null;
  private assetTemplateDetailLoadingStatus = LoadingStatusType.None;
  private totalAsset = 0;
  private importAssetTemplateList: any = [];
  private assetTemplateCreateLoadingStatus = LoadingStatusType.None;
  private assetCarryBalanceCreateLoadingStatus = LoadingStatusType.None;
  private suggestionAssetTemplateCode = "";
  private suggestionAssetTemplateCodeLoadingStatus = LoadingStatusType.None;
  private suggestionAssetUnitCode = "";
  private suggestionAssetUnitCodeLoadingStatus = LoadingStatusType.None;
  private assetUnitCreateLoadingStatus = LoadingStatusType.None;
  private exportLoadingstatus = LoadingStatusType.None;
  private importAssetCarryBalanceList: any = [];
  private autoCompleteAssetList: any = [];
  private autoCompleteAssetTemplateListLoadingStatus: any = LoadingStatusType.None;
  private assetTemplateCategoryMenuList: any = [];
  private assetTemplateCategoryMenuListLoadingStatus: any = LoadingStatusType.None;
  private assetTemplateValidateIsCanVoide = true;
  private assetTemplateValidateIsCanVoidLoadingstatus = LoadingStatusType.None;
  private isCanDeleteAssetUnit: any = false;
  private validateDeleteUnitLoadingStatus: any = LoadingStatusType.None;
  private assetUnitDeleteLoadingStatus: any = LoadingStatusType.None;
  private assetCategoryTemplateList: any = [];
  private assetCategoryDefaultTemplateList: any = [];
  private assetTemplateCountLoadingStatus: any = LoadingStatusType.None;
  private assetTemplateCountList: any = [];
  private autoCompleteAssetTemplateSearchInput: any = null;
  private updateAssetCarryBalanceLoadingStatus = LoadingStatusType.None;

  get getAssetTemplateTableLoadingStatus(): LoadingStatusType {
    return this.assetTemplateTableLoadingStatus;
  }
  get getAssetTableLoadingStatus(): LoadingStatusType {
    return this.assetTableLoadingStatus;
  }
  get getAssetDepreciationTableLoadingStatus(): LoadingStatusType {
    return this.assetDepreciationTableLoadingStatus;
  }
  get getAssetUnitTableLoadingStatus(): LoadingStatusType {
    return this.assetUnitTableLoadingStatus;
  }
  get getAssetUnitTable(): Array<AssetUnitTableModel> {
    return this.assetUnitTable;
  }
  get getAssetTemplateTableTap(): any {
    return this.assetTemplateTableTap;
  }
  get getAssetTable(): Array<AssetTableModel> {
    return this.assetTable;
  }
  get getAssetTemplateTable(): Array<AssetTemplateTableModel> {
    return this.assetTemplateTable;
  }
  get getAssetTableTap(): any {
    return this.assetTableTap;
  }
  get getAssetUnitDeleteLoadingStatus(): any {
    return this.assetUnitDeleteLoadingStatus;
  }
  get getAssetUnitTableTap(): any {
    return this.assetUnitTableTap;
  }
  get getAssetDepreciationTable(): Array<AssetDepreciationTableModel> {
    return this.assetDepreciationTable;
  }
  get getAssetDepreciationTableTap(): any {
    return this.assetDepreciationTableTap;
  }
  get getAssetDetailLoadingStatus(): LoadingStatusType {
    return this.assetDetailLoadingStatus;
  }
  get getAssetDetail(): AssetModel | null {
    return this.assetDetail;
  }
  get getAssetTemplateDetailLoadingStatus(): LoadingStatusType {
    return this.assetTemplateDetailLoadingStatus;
  }
  get getAssetTemplateDetail(): AssetTemplateModel | null {
    return this.assetTemplateDetail;
  }
  get getTotalAsset(): number {
    return this.totalAsset;
  }
  get getImportAssetTemplateList(): number {
    return this.importAssetTemplateList;
  }
  get getSuggestionAssetTemplateCodeLoadingStatus(): LoadingStatusType {
    return this.suggestionAssetTemplateCodeLoadingStatus;
  }
  get getSuggestionAssetUnitCodeLoadingStatus(): LoadingStatusType {
    return this.suggestionAssetUnitCodeLoadingStatus;
  }
  get getSuggestionAssetUnitCode(): string {
    return this.suggestionAssetUnitCode;
  }
  get getValidateDeleteUnitLoadingStatus(): LoadingStatusType {
    return this.validateDeleteUnitLoadingStatus;
  }
  get getIsCanDeleteAssetUnit(): boolean {
    return this.isCanDeleteAssetUnit;
  }
  get getSuggestionAssetTemplateCode(): string {
    return this.suggestionAssetTemplateCode;
  }
  get getAssetCarryBalanceCreateLoadingStatus(): LoadingStatusType {
    return this.assetCarryBalanceCreateLoadingStatus;
  }
  get getImportAssetCarryBalanceList(): number {
    return this.importAssetCarryBalanceList;
  }
  get getAutoCompleteAssetTemplateListLoadingStatus(): LoadingStatusType {
    return this.autoCompleteAssetTemplateListLoadingStatus;
  }
  get getAutoCompleteAssetList(): any {
    return this.autoCompleteAssetList;
  }
  get getAssetTemplateCreateLoadingStatus(): LoadingStatusType {
    return this.assetTemplateCreateLoadingStatus;
  }
  get getAssetUnitCreateLoadingStatus(): LoadingStatusType {
    return this.assetUnitCreateLoadingStatus;
  }
  get getAssetTemplateCategoryMenuList(): any {
    return this.assetTemplateCategoryMenuList;
  }
  get getAssetTemplateCategoryMenuListLoadingStatus(): LoadingStatusType {
    return this.assetTemplateCategoryMenuListLoadingStatus;
  }

  get getAssetTemplateValidateIsCanVoide(): boolean {
    return this.assetTemplateValidateIsCanVoide;
  }
  get getAssetTemplateValidateIsCanVoidLoadingstatus(): LoadingStatusType {
    return this.assetTemplateValidateIsCanVoidLoadingstatus;
  }
  get getAssetTemplateCountList(): any {
    return this.assetTemplateCountList;
  }
  get getAssetTemplateCountLoadingStatus(): LoadingStatusType {
    return this.assetTemplateCountLoadingStatus;
  }

  get getAutoCompleteAssetTemplateSearchInput(): any {
    return this.autoCompleteAssetTemplateSearchInput;
  }

  get getUpdateAssetCarryBalanceLoadingStatus() {
    return this.updateAssetCarryBalanceLoadingStatus;
  }

  @Mutation
  public SetAssetTemplateTableLoadingStatus(status: LoadingStatusType): void {
    this.assetTemplateTableLoadingStatus = status;
  }
  @Mutation
  public SetAssetTableLoadingStatus(status: LoadingStatusType): void {
    this.assetTableLoadingStatus = status;
  }
  @Mutation
  public SetAssetUnitTableLoadingStatus(status: LoadingStatusType): void {
    this.assetUnitTableLoadingStatus = status;
  }
  @Mutation
  public SetAssetUnitTable(table: any): void {
    this.assetUnitTable = ConvertToAssetUnitTable(table.unitList);
    this.assetUnitTableTap = SetTapAssetUnitTable(table.totalUnit);
  }
  @Mutation
  public SetAssetDepreciationTableLoadingStatus(status: LoadingStatusType): void {
    this.assetDepreciationTableLoadingStatus = status;
  }
  @Mutation
  public SetAssetTemplateTable(table: any): void {
    this.assetTemplateTable = ConvertToAssetTemplateTable(table.tableList);
    this.assetTemplateTableTap = SetTapAssetTemplateTable(table.transactionCount);
  }
  @Mutation
  public SetAssetTable(table: any): void {
    this.assetTable = ConvertToAssetTable(table.tableList);
    this.totalAsset = table.transactionCount;
    this.assetTableTap = SetTapAssetTable(table.transactionCount);
  }
  @Mutation
  public SetAssetDepreciationTable(table: any): void {
    this.assetDepreciationTable = ConvertToAssetDepreciationTable(table.tableList);
    this.assetDepreciationTableTap = SetTapAssetDepreciationTable(table.transactionCount);
  }
  @Mutation
  public SetAssetDetailLoadingStatus(status: LoadingStatusType): void {
    this.assetDetailLoadingStatus = status;
  }
  @Mutation
  public SetAssetDetail(detail: AssetModel): void {
    this.assetDetail = ConvertToAssetDetail(detail);
  }
  @Mutation
  public SetAssetTemplateDetailLoadingStatus(status: LoadingStatusType): void {
    this.assetTemplateDetailLoadingStatus = status;
  }
  @Mutation
  public SetAssetTemplateDetail(detail: AssetTemplateModel): void {
    this.assetTemplateDetail = ConvertToAssetTemplateDetail(detail);
  }
  @Mutation
  public SetImportAssetTemplate(input: any): void {
    const importAssetTemplateList = ConvertToImportAssetTemplateList(
      input.importAssetTemplateJsonList,
      input.unitList,
      input.assetAccountList,
      input.depreciationAccountList,
      input.accumulatedDepreciationAccountList,
      input.assetTemplateCategoryMenuList
    );
    this.importAssetTemplateList = importAssetTemplateList;
  }

  @Mutation
  public SetAssetTemplateCreateLoadingStatus(status: LoadingStatusType): void {
    this.assetTemplateCreateLoadingStatus = status;
  }
  @Mutation
  public SetAssetUnitDeleteLoadingStatus(status: LoadingStatusType): void {
    this.assetUnitDeleteLoadingStatus = status;
  }
  @Mutation
  public SetAssetUnitCreateLoadingStatus(status: LoadingStatusType): void {
    this.assetUnitCreateLoadingStatus = status;
  }

  @Mutation
  public SetGetSuggestionAssetTemplateCodeLoadingStatus(status: LoadingStatusType): void {
    this.suggestionAssetTemplateCodeLoadingStatus = status;
  }

  @Mutation
  public SetSuggestionAssetTemplateCode(code: string): void {
    this.suggestionAssetTemplateCode = code;
  }
  @Mutation
  public SetGetSuggestionAssetUnitCodeLoadingStatus(status: LoadingStatusType): void {
    this.suggestionAssetUnitCodeLoadingStatus = status;
  }

  @Mutation
  public SetSuggestionAssetUnitCode(code: string): void {
    this.suggestionAssetUnitCode = code;
  }
  @Mutation
  public SetExportLoadingstatus(status: LoadingStatusType) {
    this.exportLoadingstatus = status;
  }
  @Mutation
  public SetValidateDeleteUnitLoadingStatus(status: LoadingStatusType) {
    this.validateDeleteUnitLoadingStatus = status;
  }
  @Mutation
  public SetIsCanDeleteAssetUnit(status: boolean) {
    this.isCanDeleteAssetUnit = status;
  }
  @Mutation
  public SetAssetCarryBalanceCreateLoadingStatus(status: LoadingStatusType) {
    this.assetCarryBalanceCreateLoadingStatus = status;
  }
  @Mutation
  public SetImportAssetCarryBalanceList(input: any) {
    this.importAssetCarryBalanceList = GetImportAssetCarryBalanceList(
      input.importAssetCarryBalanceJsonList,
      input.assetTemplateList
    );
  }

  @Mutation
  public MutationSetAutoCompleteAssetList(assetList: any) {
    this.autoCompleteAssetList = assetList;
  }

  @Mutation
  public MutationSetAutoCompleteAssetTemplateListLoadingStatus(status: any) {
    this.autoCompleteAssetTemplateListLoadingStatus = status;
  }

  @Mutation
  public MutationSetAssetCategoryTemplateList(assetCategory: any) {
    const assetCategoryIndex = this.assetCategoryTemplateList.findIndex(
      (x: any) => x.categoryId == assetCategory.categoryId
    );
    if (assetCategoryIndex > -1) {
      this.assetCategoryTemplateList.splice(assetCategoryIndex, 1);
      this.assetCategoryTemplateList.push(assetCategory);
    } else {
      this.assetCategoryTemplateList.push(assetCategory);
    }
  }

  @Mutation
  public MutationSetAssetCategoryDefaultTemplateList(assetCategory: any) {
    const assetCategoryIndex = this.assetCategoryTemplateList.findIndex(
      (x: any) => x.categoryId == assetCategory.categoryId
    );
    if (assetCategoryIndex > -1) {
      this.assetCategoryDefaultTemplateList.splice(assetCategoryIndex, 1);
      this.assetCategoryDefaultTemplateList.push(assetCategory);
    } else {
      this.assetCategoryDefaultTemplateList.push(assetCategory);
    }
  }

  @Mutation
  public MutationSetAutoCompleteAssetTemplateSearchInput(input: any) {
    this.autoCompleteAssetTemplateSearchInput = {
      searchText: input.searchText,
      assetCategoryId: input.assetCategoryId,
      assetSubCategoryId: input.assetSubCategoryId,
      sequenceNumber: input.sequenceNumber,
    };
  }

  @Mutation
  public MutationResetAssetCategoryTemplateList() {
    this.assetCategoryTemplateList = [];
  }

  @Mutation
  public MutationSetAssetTemplateCategoryMenuList(assetList: any) {
    this.assetTemplateCategoryMenuList = assetList;
  }

  @Mutation
  public MutationSetAssetTemplateCategoryMenuListLoadingStatus(status: any) {
    this.assetTemplateCategoryMenuListLoadingStatus = status;
  }

  @Mutation
  public SetAssetTemplateValidateIsCanVoidLoadingstatus(status: LoadingStatusType) {
    this.assetTemplateValidateIsCanVoidLoadingstatus = status;
  }

  @Mutation
  public SetAssetTemplateValidateIsCanVoide(assetTemplateValidateIsCanVoide: boolean) {
    this.assetTemplateValidateIsCanVoide = assetTemplateValidateIsCanVoide;
  }

  @Mutation
  public MutationSetgetAssetTemplateCountList(assetCountList: any): void {
    this.assetTemplateCountList = assetCountList;
  }

  @Mutation
  public MutationSetAssetTemplateCountLoadingStatus(status: LoadingStatusType): void {
    this.assetTemplateCountLoadingStatus = status;
  }

  @Mutation
  public MutationSetUpdateAssetCarryBalanceLoadingStatus(status: LoadingStatusType) {
    this.updateAssetCarryBalanceLoadingStatus = status;
  }

  @Action
  public DoGetAssetTemplateTable(searchCriteria: any) {
    if (this.assetTemplateTableLoadingStatus != LoadingStatusType.Loading) {
      this.context.commit("SetAssetTemplateTableLoadingStatus", LoadingStatusType.Loading);
      AssetService.GetAssetTemplateTable(searchCriteria).then((res) => {
        this.context.commit("SetAssetTemplateTable", res.data.table);
        this.context.commit("SetAssetTemplateTableLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
  @Action
  public DoGetAssetUnitTable(input: any) {
    if (this.assetUnitTableLoadingStatus != LoadingStatusType.Loading) {
      this.context.commit("SetAssetUnitTableLoadingStatus", LoadingStatusType.Loading);
      AssetService.GetAssetUnitTable(input).then((res) => {
        this.context.commit("SetAssetUnitTable", res.data.unitTable);
        this.context.commit("SetAssetUnitTableLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
  @Action
  public DoGetAssetTable(searchCriteria: any) {
    if (this.assetTableLoadingStatus != LoadingStatusType.Loading) {
      this.context.commit("SetAssetTableLoadingStatus", LoadingStatusType.Loading);
      AssetService.GetAssetTable(searchCriteria).then((res) => {
        this.context.commit("SetAssetTable", res.data.table);
        this.context.commit("SetAssetTableLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
  @Action
  public DoGetAssetDepreciationTable(searchCriteria: any) {
    if (this.assetDepreciationTableLoadingStatus != LoadingStatusType.Loading) {
      this.context.commit("SetAssetDepreciationTableLoadingStatus", LoadingStatusType.Loading);
      AssetService.GetAssetDepreciationTable(searchCriteria).then((res) => {
        this.context.commit("SetAssetDepreciationTable", res.data.table);
        this.context.commit("SetAssetDepreciationTableLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
  @Action
  public DoGetAssetDetail(assetId: number) {
    if (this.assetDetailLoadingStatus != LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("SetAssetDetailLoadingStatus", LoadingStatusType.Loading);
      AssetService.GetAssetDetail(assetId).then((res) => {
        this.context.commit("SetAssetDetail", res.data.detail);
        this.context.commit("SetAssetDetailLoadingStatus", LoadingStatusType.Success);
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }
  @Action
  public DoGetAssetTemplateDetail(assetTemplateId: number) {
    if (this.assetTemplateDetailLoadingStatus != LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("SetAssetTemplateDetailLoadingStatus", LoadingStatusType.Loading);
      AssetService.GetAssetTemplateDetail(assetTemplateId).then((res) => {
        this.context.commit("SetAssetTemplateDetail", res.data.detail);
        this.context.commit("SetAssetTemplateDetailLoadingStatus", LoadingStatusType.Success);
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }
  @Action
  public DoSetImportAssetTemplate(input: any) {
    this.context.commit("SetImportAssetTemplate", input);
    router.push({ name: "importAssetTemplate", query: { emi: MerchantId().PeakEncryption() } });
  }
  @Action
  public DoCreateAssetTemplate(assetTemplateList: any) {
    const isValidated = ValidatedCreateAssetTemplate(assetTemplateList);
    if (isValidated) {
      if (this.assetTemplateCreateLoadingStatus != LoadingStatusType.Loading) {
        this.context.commit("SetAssetTemplateCreateLoadingStatus", LoadingStatusType.Loading);
        const insertAssetTemplateList = ConvertToInsertAssetTemplateList(assetTemplateList);
        AssetService.CreateAssetTemplate(insertAssetTemplateList).then((res) => {
          if (res.data.responseCode.IsSuccess()) {
            this.context.dispatch(
              "Alert/SetAlertMessage",
              {
                alertMessage: i18n.t("Success", {
                  number: insertAssetTemplateList[0].assetTemplateCode,
                  name:
                    GetLanguageType() == LanguageType.En
                      ? insertAssetTemplateList[0].nameEn
                      : insertAssetTemplateList[0].nameTh,
                }),
                typeMessage: TypeComponentNoti.Success,
              },
              { root: true }
            );
            this.context.commit("MutationResetAssetCategoryTemplateList");
            this.context.commit("SetAssetTemplateCreateLoadingStatus", LoadingStatusType.Success);
            router.replace({ name: "assetTemplate", query: { emi: MerchantId().PeakEncryption() } });
          } else {
            const alertMessage = GetMessageExceptionCode(res.data.exception);
            this.context.dispatch(
              "Alert/SetAlertMessage",
              {
                alertMessage: alertMessage,
                typeMessage: TypeComponentNoti.Error,
              },
              { root: true }
            );
            this.context.commit("SetAssetTemplateCreateLoadingStatus", LoadingStatusType.Success);
          }
        });
      }
    } else {
      this.context.dispatch(
        "Alert/SetAlertMessage",
        {
          alertMessage: i18n.t("all_validation"),
          typeMessage: TypeComponentNoti.Error,
        },
        { root: true }
      );
    }
  }
  @Action
  public DoCreateAssetUnit(assetUnit: AssetUnitModel) {
    const isValidated = ValidateUnitTemplateError(assetUnit);
    if (isValidated) {
      if (this.assetUnitCreateLoadingStatus != LoadingStatusType.Loading) {
        this.context.commit("SetAssetUnitCreateLoadingStatus", LoadingStatusType.Loading);
        const unitTemplateModel = ConvertToUnitTemplateModel(assetUnit);

        AssetService.CreateAssetUnit(unitTemplateModel).then((res) => {
          if (res.data.responseCode.IsSuccess()) {
            this.context.dispatch(
              "Alert/SetAlertMessage",
              {
                alertMessage: i18n.t("Create_Asset_Unit_Success", { message: assetUnit.unitCode }),
                typeMessage: TypeComponentNoti.Success,
              },
              { root: true }
            );
          } else {
            const alertMessage = GetMessageExceptionCode(res.data.exception);
            this.context.dispatch(
              "Alert/SetAlertMessage",
              {
                alertMessage: alertMessage,
                typeMessage: TypeComponentNoti.Error,
              },
              { root: true }
            );
          }
          this.context.commit("SetAssetUnitCreateLoadingStatus", LoadingStatusType.Success);
        });
      }
    } else {
      this.context.dispatch(
        "Alert/SetAlertMessage",
        {
          alertMessage: i18n.t("all_validation"),
          typeMessage: TypeComponentNoti.Error,
        },
        { root: true }
      );
    }
  }
  @Action
  public DoEditUnit(assetUnit: any) {
    const isValidated = ValidateUnitTemplateError(assetUnit);
    if (isValidated) {
      if (this.assetUnitCreateLoadingStatus != LoadingStatusType.Loading) {
        this.context.commit("SetAssetUnitCreateLoadingStatus", LoadingStatusType.Loading);
        const unitTemplateModel = ConvertToUnitTemplateModel(assetUnit);
        AssetService.EditUnit(unitTemplateModel).then((res) => {
          if (res.data.responseCode.IsSuccess()) {
            this.context.dispatch(
              "Alert/SetAlertMessage",
              {
                alertMessage: i18n.t("Edit_Asset_Unit_Success", { message: assetUnit.unitCode }),
                typeMessage: TypeComponentNoti.Success,
              },
              { root: true }
            );
          } else {
            const alertMessage = GetMessageExceptionCode(res.data.exception);
            this.context.dispatch(
              "Alert/SetAlertMessage",
              {
                alertMessage: alertMessage,
                typeMessage: TypeComponentNoti.Error,
              },
              { root: true }
            );
          }
          this.context.commit("SetAssetUnitCreateLoadingStatus", LoadingStatusType.Success);
        });
      }
    } else {
      this.context.dispatch(
        "Alert/SetAlertMessage",
        {
          alertMessage: i18n.t("all_validation"),
          typeMessage: TypeComponentNoti.Error,
        },
        { root: true }
      );
    }
  }
  @Action
  public DoDeleteUnit(assetUnit: any) {
    if (this.assetUnitDeleteLoadingStatus != LoadingStatusType.Loading) {
      this.context.commit("SetAssetUnitDeleteLoadingStatus", LoadingStatusType.Loading);
      AssetService.DeleteUnit(assetUnit).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: i18n.t("Delete_Asset_Unit_Success", { message: assetUnit.unitCode }),
              typeMessage: TypeComponentNoti.Success,
            },
            { root: true }
          );
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
        }
        this.context.commit("SetAssetUnitDeleteLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
  @Action
  public DoUpdateAssetTemplate(assetTemplateList: any) {
    const isValidated = ValidatedCreateAssetTemplate(assetTemplateList);
    if (isValidated) {
      if (this.assetTemplateCreateLoadingStatus != LoadingStatusType.Loading) {
        this.context.commit("SetAssetTemplateCreateLoadingStatus", LoadingStatusType.Loading);
        const insertAssetTemplateList: any = ConvertToInsertAssetTemplateList(assetTemplateList);
        AssetService.UpdateAssetTemplate(insertAssetTemplateList[0]).then((res) => {
          if (res.data.responseCode.IsSuccess()) {
            this.context.dispatch(
              "Alert/SetAlertMessage",
              {
                alertMessage: i18n.t("Edit_Asset_Group_Success", {
                  number: insertAssetTemplateList[0].assetTemplateCode,
                  name:
                    GetLanguageType() == LanguageType.En
                      ? insertAssetTemplateList[0].nameEn
                      : insertAssetTemplateList[0].nameTh,
                }),
                typeMessage: TypeComponentNoti.Success,
              },
              { root: true }
            );

            this.context.commit("MutationResetAssetCategoryTemplateList");
          }
          this.context.commit("SetAssetTemplateCreateLoadingStatus", LoadingStatusType.Success);
        });
      }
    } else {
      this.context.dispatch(
        "Alert/SetAlertMessage",
        {
          alertMessage: i18n.t("all_validation"),
          typeMessage: TypeComponentNoti.Error,
        },
        { root: true }
      );
    }
  }
  @Action
  public DoGetSuggestionAssetTemplateCode(assetTemplateSubCategory: AssetTemplateSubCategoryType) {
    if (this.suggestionAssetTemplateCodeLoadingStatus != LoadingStatusType.Loading) {
      this.context.commit("SetGetSuggestionAssetTemplateCodeLoadingStatus", LoadingStatusType.Loading);
      AssetService.GetSuggestionAssetTemplateCode(assetTemplateSubCategory).then((res) => {
        this.context.commit("SetSuggestionAssetTemplateCode", res.data.code);
        this.context.commit("SetGetSuggestionAssetTemplateCodeLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
  @Action
  public DoGetSuggestionAssetUnitCode() {
    if (this.suggestionAssetTemplateCodeLoadingStatus != LoadingStatusType.Loading) {
      this.context.commit("SetGetSuggestionAssetUnitCodeLoadingStatus", LoadingStatusType.Loading);
      AssetService.GetSuggestionAssetUnitCode().then((res) => {
        this.context.commit("SetSuggestionAssetUnitCode", res.data.code);
        this.context.commit("SetGetSuggestionAssetUnitCodeLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
  @Action
  public DoExportAsset(input: any) {
    this.context.dispatch("Loading/IsLoading", true, { root: true });
    this.context.commit("SetExportLoadingstatus", LoadingStatusType.Loading);
    AssetService.DoExportAsset(input).then((res) => {
      let alertMessage: any = "";
      let typeMessage = TypeComponentNoti.Success;

      if (res.data.responseCode.IsSuccess()) {
        if (input.isSendEmail) {
          this.context.commit("SetExportLoadingstatus", LoadingStatusType.Success);
          alertMessage = i18n.t("This_Report_Is_Sent_Email", { email: input.receiveEmailList.join(", ") });
        } else {
          this.context.commit("SetExportLoadingstatus", LoadingStatusType.Success);
          alertMessage = i18n.t("Report_Ready");
        }
      } else {
        this.context.commit("SetExportLoadingstatus", LoadingStatusType.Fail);
        alertMessage = i18n.t("Something_Wrong");
        typeMessage = TypeComponentNoti.Error;
      }
      this.context.dispatch("Loading/IsLoading", false, { root: true });
      this.context.dispatch(
        "Alert/SetAlertMessage",
        {
          alertMessage: i18n.t(alertMessage),
          typeMessage: typeMessage,
        },
        { root: true }
      );
    });
  }
  @Action
  public DoExportAssetGroup(input: any) {
    this.context.dispatch("Loading/IsLoading", true, { root: true });
    this.context.commit("SetExportLoadingstatus", LoadingStatusType.Loading);

    AssetService.DoExportAssetGroup(input).then((res) => {
      let alertMessage: any = "";
      let typeMessage = TypeComponentNoti.Success;

      if (res.data.responseCode.IsSuccess()) {
        if (input.isSendEmail) {
          this.context.commit("SetExportLoadingstatus", LoadingStatusType.Success);
          alertMessage = i18n.t("This_Report_Is_Sent_Email", { email: input.receiveEmailList.join(", ") });
        } else {
          this.context.commit("SetExportLoadingstatus", LoadingStatusType.Success);
          alertMessage = i18n.t("Report_Ready");
        }
      } else {
        this.context.commit("SetExportLoadingstatus", LoadingStatusType.Fail);
        alertMessage = i18n.t("Something_Wrong");
        typeMessage = TypeComponentNoti.Error;
      }
      this.context.dispatch("Loading/IsLoading", false, { root: true });
      this.context.dispatch(
        "Alert/SetAlertMessage",
        {
          alertMessage: i18n.t(alertMessage),
          typeMessage: typeMessage,
        },
        { root: true }
      );
    });
  }
  @Action
  public DoStopAssetDepreciation(input: any) {
    this.context.dispatch("Loading/IsLoading", true, { root: true });
    AssetService.DoStopAssetDepreciation(input).then((res) => {
      let alertMessage: any = "";
      let typeMessage = TypeComponentNoti.Success;
      if (res.data.responseCode.IsSuccess()) {
        this.context.commit("SetExportLoadingstatus", LoadingStatusType.Success);
        alertMessage = i18n.t("Stop_Depreciation_Success");
      } else {
        this.context.commit("SetExportLoadingstatus", LoadingStatusType.Fail);
        alertMessage = i18n.t("Stop_Depreciation_Fail");
        typeMessage = TypeComponentNoti.Error;
      }
      this.context.dispatch("Loading/IsLoading", false, { root: true });
      this.context.dispatch(
        "Alert/SetAlertMessage",
        {
          alertMessage: i18n.t(alertMessage),
          typeMessage: typeMessage,
        },
        { root: true }
      );
    });
  }
  @Action
  public DoGetAssetTemplateValidateIsCanVoid(assetTemplateId: any) {
    this.context.dispatch("Loading/IsLoading", true, { root: true });
    const assetTemplateIdList: any = [];
    assetTemplateIdList.push(assetTemplateId);
    this.context.commit("SetAssetTemplateValidateIsCanVoidLoadingstatus", LoadingStatusType.Loading);
    AssetService.DoGetAssetTemplateValidateIsCanVoid(assetTemplateIdList).then((res) => {
      if (res.data.responseCode.IsSuccess()) {
        this.context.commit("SetAssetTemplateValidateIsCanVoide", res.data.isCanVoide);
      } else {
        this.context.dispatch(
          "Alert/SetAlertMessage",
          {
            alertMessage: i18n.t("Something_Wrong"),
            typeMessage: TypeComponentNoti.Error,
          },
          { root: true }
        );
      }
      this.context.dispatch("Loading/IsLoading", false, { root: true });
      this.context.commit("SetAssetTemplateValidateIsCanVoidLoadingstatus", LoadingStatusType.Success);
    });
  }
  @Action
  public ValidateDeleteUnit(assetUnitId: number) {
    this.context.dispatch("Loading/IsLoading", true, { root: true });
    this.context.commit("SetValidateDeleteUnitLoadingStatus", LoadingStatusType.Loading);
    AssetService.ValidateDeleteUnit(assetUnitId).then((res) => {
      let alertMessage: any = "";
      let typeMessage = TypeComponentNoti.Success;
      if (res.data.responseCode.IsSuccess()) {
        this.context.commit("SetIsCanDeleteAssetUnit", res.data.isCanDeleteAssetUnit);
        if (!res.data.isCanDeleteAssetUnit) {
          alertMessage = i18n.t("Stop_Depreciation_Fail");
          typeMessage = TypeComponentNoti.Error;
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: i18n.t(alertMessage),
              typeMessage: typeMessage,
            },
            { root: true }
          );
        }
      } else {
        alertMessage = i18n.t("Stop_Depreciation_Fail");
        typeMessage = TypeComponentNoti.Error;
        this.context.dispatch(
          "Alert/SetAlertMessage",
          {
            alertMessage: i18n.t(alertMessage),
            typeMessage: typeMessage,
          },
          { root: true }
        );
      }
      this.context.commit("SetValidateDeleteUnitLoadingStatus", LoadingStatusType.Success);
      this.context.dispatch("Loading/IsLoading", false, { root: true });
    });
  }
  @Action
  public DoVoidAssetTemplate(input: any) {
    this.context.dispatch("Loading/IsLoading", true, { root: true });
    const assetTemplateIdList: any = [];
    assetTemplateIdList.push(input.assetTemplateId);
    AssetService.DoVoidAssetTemplate(assetTemplateIdList).then((res) => {
      const alertMessage: any = "";
      const typeMessage = TypeComponentNoti.Success;
      if (res.data.responseCode.IsSuccess()) {
        this.context.commit("SetExportLoadingstatus", LoadingStatusType.Success);
        this.context.dispatch(
          "Alert/SetAlertMessage",
          {
            alertMessage: i18n.t("Delete_Asset_Group_Success", {
              number: input.assetTemplateDetail.assetTemplateCode,
              name:
                GetLanguageType() == LanguageType.En
                  ? input.assetTemplateDetail.nameEn
                  : input.assetTemplateDetail.nameTh,
            }),
            typeMessage: TypeComponentNoti.Success,
          },
          { root: true }
        );
        router.push({ name: "assetTemplate", query: { emi: MerchantId().PeakEncryption() } });
        this.context.commit("MutationResetAssetCategoryTemplateList");
      } else {
        this.context.commit("SetExportLoadingstatus", LoadingStatusType.Fail);
        const alertMessage = GetMessageExceptionCode(res.data.exception);
        this.context.dispatch(
          "Alert/SetAlertMessage",
          {
            alertMessage: alertMessage,
            typeMessage: TypeComponentNoti.Error,
          },
          { root: true }
        );
      }
      this.context.dispatch("Loading/IsLoading", false, { root: true });
      this.context.dispatch(
        "Alert/SetAlertMessage",
        {
          alertMessage: i18n.t(alertMessage),
          typeMessage: typeMessage,
        },
        { root: true }
      );
    });
  }
  @Action
  public DoVoidAsset(input: any) {
    this.context.dispatch("Loading/IsLoading", true, { root: true });
    const assetIdList: any = [];
    assetIdList.push(input.assetId);
    AssetService.DoVoidAsset(assetIdList).then((res) => {
      this.context.dispatch("Loading/IsLoading", false, { root: true });
      if (res.data.responseCode.IsSuccess()) {
        this.context.commit("SetExportLoadingstatus", LoadingStatusType.Success);
        this.context.dispatch(
          "Alert/SetAlertMessage",
          {
            alertMessage: i18n.t("Delete_Asset_Success", {
              number: input.assetDetail.uniqueId,
              name:
                GetLanguageType() == LanguageType.En
                  ? input.assetTemplateDetail.nameEn
                  : input.assetTemplateDetail.nameTh,
            }),
            typeMessage: TypeComponentNoti.Success,
          },
          { root: true }
        );
        router.push({
          name: "assetTemplateDetail",
          query: { emi: MerchantId().PeakEncryption(), eii: input.assetTemplateDetail.id.PeakEncryption() },
        });
      } else {
        this.context.commit("SetExportLoadingstatus", LoadingStatusType.Fail);
        const alertMessage = GetMessageExceptionCode(res.data.exception);
        this.context.dispatch(
          "Alert/SetAlertMessage",
          {
            alertMessage: alertMessage,
            typeMessage: TypeComponentNoti.Error,
          },
          { root: true }
        );
      }
    });
  }
  @Action
  public DoInsertAssetCarryBalance(input: any) {
    const assetCarryBalanceRawList = input.assetCarryBalanceRawList;
    const isImport = input.isImport;
    const assetTemplate = input.assetTemplate;
    const isLockPeriod = input.isLockPeriod;
    const lockPeriodEndDate = input.lockPeriodEndDate;
    setTimeout(() => {
      const { isValidated, validatedErrorType } = ValidateAssetCarryBalance(
        assetCarryBalanceRawList,
        isLockPeriod,
        lockPeriodEndDate
      );
      if (isValidated) {
        this.context.dispatch("Loading/IsLoading", true, { root: true });
        this.context.commit("SetAssetCarryBalanceCreateLoadingStatus", LoadingStatusType.Loading);
        const insertAssetList = GetInsertAssetCarryBalance(assetCarryBalanceRawList);
        AssetService.DoInsertAssetCarryBalance(insertAssetList).then((res) => {
          let alertMessage: any = "";
          const typeMessage = TypeComponentNoti.Success;
          if (res.data.responseCode.IsSuccess()) {
            this.context.commit("SetExportLoadingstatus", LoadingStatusType.Success);
            if (isImport) {
              alertMessage = i18n.t("Import_Record_Asset_Balance_Success");
            } else {
              let assetCode = "";
              if (res.data.insertedList && res.data.insertedList.length > 0) {
                assetCode = res.data.insertedList[0].number;
              }
              this.context.dispatch(
                "Alert/SetAlertMessage",
                {
                  alertMessage: i18n.t("Success_AssetCarryBalance", {
                    assetCode: assetTemplate.assetTemplateCode,
                    name: GetLanguageType() == LanguageType.En ? assetTemplate.nameEn : assetTemplate.nameTh,
                  }),
                  typeMessage: TypeComponentNoti.Success,
                },
                { root: true }
              );
            }
          } else {
            this.context.commit("SetExportLoadingstatus", LoadingStatusType.Fail);
            const alertMessage = GetMessageExceptionCode(res.data.exception);
            this.context.dispatch(
              "Alert/SetAlertMessage",
              {
                alertMessage: alertMessage,
                typeMessage: TypeComponentNoti.Error,
              },
              { root: true }
            );
          }
          this.context.dispatch("Loading/IsLoading", false, { root: true });
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: i18n.t(alertMessage),
              typeMessage: typeMessage,
            },
            { root: true }
          );
          this.context.commit("SetAssetCarryBalanceCreateLoadingStatus", LoadingStatusType.Success);
        });
      } else {
        if (validatedErrorType == ValidatedErrorCarryBalanceType.Depreciation) {
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: i18n.t("Must_be_less_than_asset_value"),
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
        } else if (validatedErrorType == ValidatedErrorCarryBalanceType.ScrapValue) {
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: i18n.t("Higher_than_scrap_value"),
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
        } else if (validatedErrorType == ValidatedErrorCarryBalanceType.LockByPeriod) {
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: i18n.t("Lock_old_entries", { date: lockPeriodEndDate.GetDateFormat() }),
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
        } else {
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: i18n.t("all_validation"),
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
        }
      }
    }, 0);
  }
  @Action
  public DoSetImportCarryBalance(importAssetCarryBalanceJsonList: any) {
    this.context.dispatch("Loading/IsLoading", true, { root: true });
    const assetTemplateCodeList = GetAssetTemplateCode(importAssetCarryBalanceJsonList);
    AssetService.DoGetAssetTemplateByCode(assetTemplateCodeList).then((res) => {
      this.context.commit("SetImportAssetCarryBalanceList", {
        importAssetCarryBalanceJsonList: importAssetCarryBalanceJsonList,
        assetTemplateList: res.data.assetTemplateList,
      });
      router.push({ name: "importAssetCarryBalance", query: { emi: MerchantId().PeakEncryption() } });
      this.context.dispatch("Loading/IsLoading", false, { root: true });
    });
  }
  @Action
  public DoGetAutoCompleteAssetTemplate(input: any) {
    if (this.autoCompleteAssetTemplateListLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSetAutoCompleteAssetTemplateListLoadingStatus", LoadingStatusType.Loading);
      let assetCategory = {
        categoryId: input.assetCategoryId,
        subCategoryList: [] as any,
      };

      const assetSubCategory = {
        subCategoryId: input.assetSubCategoryId,
        assetTemplateList: [],
      };

      let isLoadAssetTemplate = false;
      let findAssetCategory: any = null;
      let findAssetSubCategory: any = null;

      findAssetCategory = this.assetCategoryDefaultTemplateList.find((x: any) => x.categoryId == input.assetCategoryId);
      if (!findAssetCategory) {
        isLoadAssetTemplate = true;
      } else {
        findAssetSubCategory = findAssetCategory.subCategoryList.find(
          (x: any) => x.subCategoryId == input.assetSubCategoryId
        );
        if (!findAssetSubCategory) {
          assetCategory = NewObject(findAssetCategory);
          isLoadAssetTemplate = true;
        } else {
          if (input.searchText !== "") {
            assetCategory = NewObject(findAssetCategory);
            isLoadAssetTemplate = true;
          }
        }
      }
      if (isLoadAssetTemplate) {
        AssetService.DoGetAutoCompleteAssetTemplate(input).then((res) => {
          if (res.data.responseCode.IsSuccess()) {
            const assetTemplateList = ConvertToAssetTemplateList(res.data.assetTemplateAutoCompleteList);
            assetSubCategory.assetTemplateList = assetTemplateList;
            assetCategory.subCategoryList.push(assetSubCategory);
            if (input.searchText == "") {
              this.context.commit("MutationSetAssetCategoryDefaultTemplateList", assetCategory);
            }
            this.context.commit("MutationSetAssetCategoryTemplateList", assetCategory);
            this.context.commit("MutationSetAutoCompleteAssetTemplateSearchInput", input);
            input.transactionItem.optionAssetTemplateList = assetTemplateList;
          }
          this.context.commit("MutationSetAutoCompleteAssetTemplateListLoadingStatus", LoadingStatusType.Success);
        });
      } else {
        input.transactionItem.optionAssetTemplateList = NewObject(findAssetSubCategory.assetTemplateList);
        setTimeout(() => {
          this.context.commit("MutationSetAutoCompleteAssetTemplateListLoadingStatus", LoadingStatusType.Success);
        }, 250);
      }
    }
  }
  @Action
  public DoGetAssetTemplateCategoryMenu() {
    if (this.assetTemplateCategoryMenuListLoadingStatus != LoadingStatusType.Loading) {
      this.context.commit("MutationSetAssetTemplateCategoryMenuListLoadingStatus", LoadingStatusType.Loading);
      AssetService.DoGetAssetTemplateCategoryMenu().then((res) => {
        this.context.commit("MutationSetAssetTemplateCategoryMenuList", res.data.assetCategoryOptionList);
        this.context.commit("MutationSetAssetTemplateCategoryMenuListLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
  @Action
  public DoGetAssetTemplateCount() {
    if (this.assetTemplateCountLoadingStatus != LoadingStatusType.Loading) {
      this.context.commit("MutationSetAssetTemplateCountLoadingStatus", LoadingStatusType.Loading);
      AssetService.GetAssetTemplateCount().then((res) => {
        this.context.commit("MutationSetgetAssetTemplateCountList", res.data.assetTemplateCountList);
        this.context.commit("MutationSetAssetTemplateCountLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
  @Action
  public DoUpdateAssetCarryBalance(input: any) {
    const assetCarryBalanceRawList = [input.asset];
    const assetTemplate = input.assetTemplate;
    const { isValidated } = ValidateAssetCarryBalanceForUpdate(assetCarryBalanceRawList);
    if (isValidated) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("MutationSetUpdateAssetCarryBalanceLoadingStatus", LoadingStatusType.Loading);
      const updateAsset = GetUpdateAssetCarryBalance(assetCarryBalanceRawList[0]);
      AssetService.DoUpdateAssetCarryBalance(updateAsset).then((res) => {
        let alertMessage: any = "";
        let typeMessage = TypeComponentNoti.Success;
        if (res.data.responseCode.IsSuccess()) {
          alertMessage = i18n.t("Success_UpdateAssetCarryBalance", {
            number: input.assetUniqueId,
            name: GetLanguageType() == LanguageType.En ? assetTemplate.nameEn : assetTemplate.nameTh,
          });
        } else {
          typeMessage = TypeComponentNoti.Error;
          alertMessage = GetMessageExceptionCode(res.data.exception);
        }
        this.context.dispatch(
          "Alert/SetAlertMessage",
          {
            alertMessage: i18n.t(alertMessage),
            typeMessage: typeMessage,
          },
          { root: true }
        );
        this.context.commit("MutationSetUpdateAssetCarryBalanceLoadingStatus", LoadingStatusType.Success);
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    } else {
      this.context.dispatch(
        "Alert/SetAlertMessage",
        {
          alertMessage: i18n.t("all_validation"),
          typeMessage: TypeComponentNoti.Error,
        },
        { root: true }
      );
    }
  }
}

export default Asset;
